import React, { useContext, useMemo } from 'react';
import useStyles from './styles';
import { Box, Typography } from '@mui/material';
//=================

import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import InfoButton from '../InfoButton';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const CustomHeading = ({
	name,
	heading,
	headingStyles = {},
	containerStyles,
	headingClassName = '',
	variantType = 'h3',
	showInfoButton = false,
	infoMessage = '',
	infoButtonProps = {},
	system = SYSTEMS.FRAMERATE
}) => {
	const classes = useStyles();
	const { getAccessControlSet } = useContext(UserContext);

	/**
	 * This variable contains a set of strings that signifies if this input is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const textFieldControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.HEADING_NAMES, name);
	}, [getAccessControlSet, name, system]);

	return (
		<>
			{!textFieldControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<Box style={containerStyles}>
					<Typography
						className={`${classes.heading} ${headingClassName}`}
						style={headingStyles}
						fontWeight={600}
						variant={variantType}
					>
						{heading || ''}
						{showInfoButton && heading?.trim() && (
							<InfoButton message={infoMessage} {...infoButtonProps} />
						)}
					</Typography>
				</Box>
			)}
		</>
	);
};
export default CustomHeading;
